<template>
    <div class="home">
        <vHeader/>
        <div class="content-box">
            <router-view class="content-view"></router-view>
        </div>
    </div>
</template>
<script>
import vHeader from '../components/header'
export default {
    components:{
        vHeader
    }
}
</script>
<style scoped>
.content-box{
    background: #F5F6FA;
}
.home{
    padding-top: 66px;
}
</style>
